import { render, staticRenderFns } from "./UploadHDImg.vue?vue&type=template&id=18946ed2&scoped=true"
import script from "./UploadHDImg.vue?vue&type=script&lang=js"
export * from "./UploadHDImg.vue?vue&type=script&lang=js"
import style0 from "./UploadHDImg.vue?vue&type=style&index=0&id=18946ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18946ed2",
  null
  
)

export default component.exports